export default "__VITE_ASSET__BVm8g0bb__"